import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'components/mui/Modal'
import Typography from 'components/mui/Typography'
// import { Box } from '@mui/material'
import fetchingDetailsGif from 'assets/fetchingdetails.gif'
import Box from 'components/mui/AppBoxComponent'
import { flexDirection } from '@mui/system'

/**
 * LoadingModal - Modal component for displaying loading states
 * @component
 * @param {Object} props - Component props
 * @returns {React.ReactElement} LoadingModal
 */
const FetchingDetailModal = ({
  open,
  title = "Account Verification in Progress",
  description = "A small test deposit is being made to verify your account securely. Please wait a moment.",
  spinnerColor = "#42A5F5",
  spinnerSize = 40,
  isMobile = false
}) => {
  // Component scope - Constants and static data
  const modalStyle = {
    width: isMobile ? '90%' : 400,
    maxWidth: '90vw',
    bgcolor: '#13172A',
    borderRadius: '12px',
    p: 4,
    // border: '2px #FFFFFF',
    borderOpacity: 0.3,
  }

  const titleStyle = {
    color: '#FFFFFF',
    fontSize: '20px',
    fontWeight: '600',
    textAlign: 'center',
    marginBottom: '16px',
    lineHeight: '1.2',
  }

  const descriptionStyle = {
    color: '#FFFFFF',
    fontSize: '14px',
    textAlign: 'center',
    marginBottom: '32px',
    lineHeight: '1.4',
  }

  const imageContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }

  const gifImageStyle = {
    width: '100%',
    maxWidth: '200px',
    height: 'auto',
  }

  // Return/rendering
  return (
    <Modal open={open} sx={{
      display: "flex", justifyContent: "center"
    }}>
      <Box sx={modalStyle}>
        {/* Title */}
        <Typography sx={titleStyle}>
          {title}
        </Typography>

        {/* Description */}
        <Typography sx={descriptionStyle}>
          {description}
        </Typography>

        {/* Loading GIF */}
        <Box sx={imageContainerStyle}>
          <img
            src={fetchingDetailsGif}
            alt="Fetching details"
            style={gifImageStyle}
          />
        </Box>
      </Box>
    </Modal>
  )
}

FetchingDetailModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  description: PropTypes.string
}

FetchingDetailModal.defaultProps = {
  title: "Fetching Details...",
  description: "Please wait while we fetch your details."
}

export default FetchingDetailModal
